<template>
  <div class="privacy-policy">
    <PageTitle>Политика обработки персональных данных</PageTitle>
    <p class="text-body-2 text-ui-kit-text">
      Настоящая Политика обработки персональных данных (далее – Политика) действует
      в отношении всей информации, которую Администрация, являющаяся владельцем группы тематических сайтов «МедТочка»,
      «Medtochka», «Ydoc», «ПроДокторов», «ПроТаблетки», «ПроБолезни», «МедОтвет»,
      «МедЛок», «МедТочка для врача», «МедФлекс» (далее - «Сайт»),
      а также программы для ЭВМ «Личный кабинет пациента МедТочка» (далее - «Система МедТочка»),
      может получить о пользователе во время использования им любого из сервисов, служб,
      программ и продуктов (далее – Сервисы) и является неотъемлемой частью Пользовательского соглашения.
      Согласие пользователя на предоставление и обработку персональной информации,
      данное им в соответствии с настоящей Политикой в рамках использования одного из Сервисов,
      распространяется на все Сервисы Сайта и Системы МедТочка.
      Использование Сервисов Сайта и/или Системы МедТочка
      означает безоговорочное согласие Пользователя с настоящей Политикой
      и указанными в ней условиями обработки его персональной информации; в случае несогласия с этими условиями
      Пользователь должен воздержаться от использования Сервисов Сайта и/или Системы МедТочка.
    </p>

    <ol class="text-h6 mt-6 text-ui-kit-text">
      <li>
        Термины и определения.
        <ol class="text-body-2 text-ui-kit-text">
          <li>
            Сайт — информация, размещенная в информационно-телекоммуникационной сети Интернет по определенным сетевым адресам, в совокупности с комплексом исключительных прав (на доменные имена, базы данных и программы для электронных вычислительных машин), осуществление которых обеспечивает доступ к такой информации. Под Сайтом, используемым в тексте данной Политики, понимается сайт, расположенный в сети Интернет по адресу: https://medtochka.[Доменная зона], а также сайты функционал, которых интегрируется с вышеуказанным сайтом, расположенные по адресам: https://medtochka.[Доменная зона], https://ydoc.[Доменная зона], https://prodoctorov.ru, https://protabletky.ru, https://probolezny.ru, https://medotvet.me, https://medlock.[Доменная зона], https://medrocket.me, https://vrach.medtochka.[Доменная зона], https://medflex.[Доменная зона].
          </li>
          <li>
            Пользователь — любой посетитель Сайта и/или Системы МедТочка,
            не зависимо от наличия у него регистрации на Сайте и/или в Системе МедТочка.
          </li>
          <li>
            Администрация — коллектив пользователей Сайта и Системы МедТочка,
            уполномоченных владельцем группы тематических ресурсов проводить мероприятия
            по обеспечению функционирования Сайта и Системы МедТочка.
          </li>
          <li>
            Персональная информация пользователя — информация,
            которую Пользователь предоставляет о себе самостоятельно при подаче заявки на регистрацию
            или в процессе использования Сервисов Сайта и/или Системы МедТочка,
            включая персональные данные пользователя; данные, которые автоматически передаются Сервисам Сайта
            и Системы МедТочка в процессе их использования с помощью установленного
            на устройстве Пользователя программного обеспечения, в том числе IP-адрес, информация из cookie,
            информация о браузере пользователя (или иной программе, с помощью которой осуществляется доступ
            к Сервисам и/или Системе МедТочка), время доступа, адрес запрашиваемой страницы;
            иная информация о пользователе, сбор и/или предоставление которой необходимо
            для использования Системы МедТочка.
          </li>
          <li>
            Обработка персональных данных — любое действие (операция) или совокупность действий (операций),
            совершаемых с использованием средств автоматизации или
            без использования таких средств с персональными данными, включая сбор, запись,
            систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение,
            использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование,
            удаление, уничтожение персональных данных.
          </li>
        </ol>
      </li>
      <li>
        Общие положения
        <ol class="text-body-2 text-ui-kit-text">
          <li>
            Настоящая Политика применима только к Сервисам Сайта и Системе МедТочка.
            Администрация не контролирует и не несет ответственность за сайты и программы для ЭВМ третьих лиц,
            на которые Пользователь может перейти по ссылкам, доступным на Сайте и/или в Системе МедТочка.
            На таких сайтах у пользователя может собираться или запрашиваться иная персональная информация,
            а также могут совершаться иные действия.
          </li>
          <li>
            Администрация не проверяет достоверность персональной информации, предоставляемой пользователями,
            и не осуществляет контроль за их дееспособностью. Однако Администрация исходит из того,
            что пользователь предоставляет достоверную и достаточную персональную информацию по вопросам,
            предлагаемым в форме регистрации, а также при загрузке информации в Систему МедТочка.
          </li>
          <li>
            Предоставляя данные третьих лиц, необходимые для использования Сайта и Системы МедТочка,
            Пользователь подтверждает получение им согласия этих лиц на обработку их персональных данных
            или наличие у Пользователя полномочий на выражение согласия от имени таких лиц.
            Ответственность за правомерность предоставления и достоверность персональных данных Пользователя и иных лиц,
            данные которых сообщены, несет Пользователь.
            Поскольку Администрация не обязана проводить установление личности Пользователя, то она не отвечает за то,
            что Пользователь действительно является тем лицом, от имени которого осуществлена регистрация на Сайте,
            и не несет ответственности за возможный ущерб, причиненный другим Пользователям или иным лицам в случае,
            если Пользователь не является таким лицом.
          </li>
          <li>
            В случае если один Пользователь посредством использования Сервисов Системы МедТочка предоставил другому
            Пользователю доступ к своим персональным данным, Пользователь, получивший доступ к данным,
            обязуется соблюдать условия конфиденциальности в отношении этих данных в соответствии
            с действующим законодательством страны регистрации Правообладателя
            и/или страны регистрации доменного имени Сайта.
          </li>
        </ol>
      </li>
      <li>
        Цели сбора и обработки персональной информации пользователей
        <ol class="text-body-2 text-ui-kit-text">
          <li>
            Администрация собирает и хранит только те персональные данные,
            которые необходимы для работоспособности Сайта и Системы МедТочка.
          </li>
          <li>
            Персональная информация пользователя может использоваться в следующих целях:
            <ol>
              <li>
                Идентификация стороны в рамках использования Сервисов Сайта и Системы МедТочка;
              </li>
              <li>
                Предоставление пользователю персонализированных Сервисов;
              </li>
              <li>
                Связь с пользователем в случае необходимости, в том числе направление уведомлений,
                запросов и информации, связанных с использованием Сервисов, оказанием услуг,
                а также обработка запросов и заявок от пользователя;
              </li>
              <li>
                Улучшение качества Сервисов Системы МедТочка, удобства их использования,
                разработка новых Сервисов и услуг;
              </li>
              <li>
                Проведение статистических и иных исследований на основе обезличенных данных;
              </li>
              <li>
                Направление информационных и рекламных сообщений;
              </li>
              <li>
                Запись на прием к врачу или диагностику;
              </li>
              <li>
                Связь со Службой поддержки пользователей Сайта и Системы МедТочка;
              </li>
              <li>
                Публикация отзывов о врачах, диагностике и лечебно-профилактических учреждениях.
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Условия обработки персональной информации пользователя и её передачи третьим лицам.
        <ol class="text-body-2 text-ui-kit-text">
          <li>
            Администрация хранит Персональную информацию пользователей в соответствии
            с требованиями действующего законодательства страны регистрации Правообладателя
            и/или страны регистрации доменного имени Сайта.
          </li>
          <li>
            В отношении Персональной информации пользователя сохраняется ее конфиденциальность,
            кроме случаев добровольного предоставления Пользователем информации о себе для общего доступа
            всем пользователям Сайта и/или Системы МедТочка.
          </li>
          <li>
            Администрация вправе передать персональную информацию пользователя третьим лицам в следующих случаях:
            <ol>
              <li>
                Пользователь явно выразил свое согласие на такие действия;
              </li>
              <li>
                Передача необходима в рамках использования Пользователем определенного
                Сервиса Системы МедТочка либо для оказания услуг Пользователю,
                при этом обеспечивается конфиденциальность персональной информации.
                Использование Сервисов Системы МедТочка означает безоговорочное согласие
                Пользователя на передачу Администрацией персональных данных Пользователя третьим лицам,
                если такая передача необходима с целью реализации целей обработки персональных данных;
              </li>
              <li>
                Передача предусмотрена законодательством страны регистрации Правообладателя
                и/или страны регистрации доменного имени Сайта или иным применимым законодательством
                в рамках установленной законодательством процедуры;
              </li>
              <li>
                Такая передача происходит в рамках продажи или иной передачи бизнеса (полностью или в части),
                при этом к приобретателю переходят все обязательства по соблюдению условий
                настоящей Политики применительно к полученной им персональной информации;
              </li>
              <li>
                В целях обеспечения возможности защиты прав и законных интересов Администрации
                или третьих лиц в случаях, когда пользователь нарушает
                Пользовательское соглашение и/или настоящую Политику.
              </li>
            </ol>
          </li>
          <li>
            Администрация вправе собирать, использовать и передавать третьим лицам
            по собственному усмотрению обезличенные данные (без персональных),
            загруженные Пользователем в Систему МедТочка и относящиеся в полной
            или частичной мере к объектам исследования медицинской статистики или другим видам анализа в научных целях,
            а также для улучшения качества работы Сайта и Системы МедТочка.
          </li>
          <li>
            Администрация принимает все необходимые меры для защиты любых персональных данных,
            предоставляемых пользователями. Доступ к персональным данным имеют
            только уполномоченные сотрудники Администрации, уполномоченные сотрудники сторонних компаний
            (т.е. поставщиков услуг) или деловых партнеров Администрации, подписавшие договор о конфиденциальности
            и защите персональных данных. Все сотрудники Администрации, имеющие доступ к персональным данным,
            должны придерживаться политики по обеспечению конфиденциальности и защиты персональных данных.
            В целях обеспечения конфиденциальности информации
            и защиты персональных данных Администрация поддерживает соответствующую ИТ-среду и принимает все меры,
            необходимые для предотвращения несанкционированного доступа.
          </li>
          <li>
            Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки.
            Не допускается избыточность обрабатываемых персональных данных по отношению к заявленным целям их обработки.
          </li>
          <li>
            Администрация вправе запрашивать и обрабатывать следующий перечень персональных данных:
            фамилия, имя, отчество, пол, возраст, дата рождения, номер телефона, адрес электронной почты,
            данные документов удостоверяющих личность, СНИЛС, данные свидетельства о рождении,
            данные о фактах обращения, а также о намерении обратиться,
            к врачу и/или в лечебно-профилактическое учреждение для получения медицинской помощи,
            данные о медицинских заключениях, диагнозах, симптомах, любые данные о здоровье,
            необходимые для использования Сервисов Сайта или Системы МедТочка в целом, данные из медицинских документов,
            данные о местоположении, данные микрофона (голос), данные камеры (изображение),
            иная информация о Пользователе указанная и/или загружаемая им или третьими лицами
            в персонализированный Сервис Сайта (личный кабинет) и/или в Систему МедТочка.
          </li>
          <li>
            Пользователь дает согласие на обработку персональных данных и подтверждает свое согласие
            путем использования средств простой электронной подписи,
            в соответствии с п. 5.2. Пользовательского соглашения.
          </li>
          <li>
            Согласие на обработку персональных данных действует бессрочно с момента его предоставления.
            Согласие может быть отозвано в любой момент путем подачи письменного заявления
            Пользователя Администрации с указанием данных, определенных законодательством
            страны регистрации Правообладателя и/или страны регистрации доменного имени Сайта.
          </li>
        </ol>
      </li>
      <li>
        Иные положения.
        <ol class="text-body-2 text-ui-kit-text">
          <li>
            Администрация имеет право вносить изменения в настоящую Политику конфиденциальности.
            При внесении изменений в актуальной редакции указывается дата последнего обновления.
            Новая редакция Политики вступает в силу с момента ее размещения,
            если иное не предусмотрено новой редакцией Политики.
          </li>
          <li>
            К настоящей Политике и отношениям между пользователем и Администрацией Сайта,
            возникающим в связи с применением Политики обработки персональных данных,
            подлежит применению действующее законодательство страны регистрации Правообладателя
            и/или страны регистрации доменного имени Сайта.
          </li>
          <li>
            Обращения по вопросам настоящей Политики необходимо направлять
            в адрес Администрации по электронной почте help@medrocket.me.
          </li>
        </ol>
      </li>
    </ol>
  </div>
</template>
